/*
 * This file is generated by parrot must
 * DOCUMENT LIST:
 * parrot must: http://gitlab.alibaba-inc.com/parrot/parrot-tool-must
 * @ali/global-locale: http://gitlab.alibaba-inc.com/parrot/global-locale
 * @ali/global-string-format: http://gitlab.alibaba-inc.com/parrot/global-string-format
 */

import { getQueryStringArgs } from '@/utils/url-parse';
import locale from '@ali/global-locale';
import stringFormat from '@ali/global-string-format';
import strings from './strings';
import { getCookie } from '@/utils';

const supportLanguages = ['zh-CN', 'en-US'];
let language; // Current language
let intl; // Instance of intl-universal. Create by provideIntl
/**
 * update instance of intl universal
 */
function update() {
  const { lang } = locale.getLocale();
  language = lang;
  intl = stringFormat.init(lang, strings);
}

/**
 * change current language
 * @param {string} langTag language tag config above
 */
function change(langTag) {
  locale.setLang(langTag);
  update();
}
/**
 * Format string by key
 * For example:
 * $i18n.get('jsx.home.title'),
 * $i18n.get({
 *    id: 'jsx.home.hello',
 *    defaultMessage: 'Hello {name}' // not required
 * },{
 *  name: 'Alice'
 * })
 * More syntax: https://formatjs.io/guides/message-syntax/
 * @param {string|object} id key or object
 * @param {object} variable variable for id
 * @return {string} format message
 */
function get(id, variable?) {
  if (!intl) update();
  if (typeof id === 'string') {
    return stringFormat.format(
      {
        id,
      },
      variable,
    );
  } else if (typeof id === 'object' && id.dm) {
    id.defaultMessage = id.dm;
  }
  return stringFormat.format(
    {
      id: id.id,
      defaultString: id.dm,
    },
    variable,
  );
}

const getLocale = (): string => {
  // 优先从url获取语言配置
  const { lang = undefined } = getQueryStringArgs();
  // url中无语言配置时从cookie中获取语言设置
  const cookieLang = getCookie('x_app_locale').replace('_', '-');
  // 最后默认根据浏览器设置加载语音
  const navLang = navigator.language === 'zh-CN' ? 'zh-CN' : 'en-US';
  let lng = lang || cookieLang || navLang;
  if(!supportLanguages.includes(lng)) {
    lng = 'en-US';
  }

  if (language !== lng) {
    /**
 * 语言切换：中文 (zh-CN)、英文 (en-US)
 */
    change(lng)
  }

  return lng
}

/**
* 语言切换：中文 (zh-CN)、英文 (en-US)
*/
getLocale()


export default {
  get,
  update,
  change,
  get language() {
    return getLocale()
  },
  get i18nLanguage() {
    return getLocale()?.replace('-', '_') || ''
  },
  get siteLocale() {
    return getLocale()
  }

};
